"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.truncateWords = void 0;
var truncateWords = function (str, options) {
  if (!str) {
    return '';
  }
  var _a = options.max,
    max = _a === void 0 ? 10 : _a,
    _b = options.ellipsis,
    ellipsis = _b === void 0 ? '...' : _b,
    _c = options.glue,
    glue = _c === void 0 ? ' ' : _c;
  var array = str.trim().split(' ');
  var suffix = ellipsis && array.length > max ? '...' : '';
  return "".concat(array.slice(0, max).join(glue)).concat(suffix);
};
exports.truncateWords = truncateWords;